import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {PostRefundCreateProcedure} from 'domain/usecases/private/refund/request/post-create-procedure';
import {RemoteRefundPostCreateProcedure} from 'data/usecases/private/refund/request/remote-post-create-procedure';
import {RefundFlowEndPoints} from '../../../endpoints';

export const makePostRefundCreateProcedure = (): PostRefundCreateProcedure =>
	new RemoteRefundPostCreateProcedure(
		makeBFFApiUrl(RefundFlowEndPoints.procedure),
		makeAuthorizeHttpClientDecorator(),
	);
